import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n        /* stylelint-disable-next-line media-query-no-invalid */\n        @media ",
        " {\n          background-image: url('",
        "",
        "/bg-",
        "-",
        ".jpg');\n\n          @media (min-resolution: 2dppx) {\n            background-image: url('",
        "",
        "/bg-",
        "-",
        "@2x.jpg');\n          }\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "@emotion/styled";
import { css } from "@emotion/react";
var imagePath = "/bm/global/graphic/image/widget";
var sizes = [
    {
        width: 250,
        height: 250,
        media: "(max-width: 250px) and (max-height: 250px)"
    },
    {
        width: 300,
        height: 250,
        media: "(min-width: 251px) and (max-width: 300px) and (max-height: 250px)"
    },
    {
        width: 300,
        height: 400,
        media: "(min-width: 251px) and (min-height: 251px) and (max-width: 300px) and (max-height: 400px)"
    },
    {
        width: 320,
        height: 480,
        media: "(min-width: 301px) and (max-width: 320px) and (max-height: 480px)"
    },
    {
        width: 300,
        height: 600,
        media: "(min-width: 251px) and (min-height: 401px) and (max-width: 300px) and (max-height: 600px)"
    },
    {
        width: 800,
        height: 250,
        media: "(min-width: 321px) and (max-width: 800px)"
    },
    {
        width: 970,
        height: 250,
        media: "(min-width: 801px) and (max-width: 970px)"
    }, 
];
var Wrapper = /*#__PURE__*/ styled("div", {
    target: "ea3dla20"
})("position:relative;z-index:1;display:flex;width:100vw;height:100vh;flex-direction:column;justify-content:space-between;background-repeat:no-repeat;background-size:cover;", function(param) {
    var baseImageUrl = param.baseImageUrl;
    return sizes.map(function(param) {
        var width = param.width, height = param.height, media = param.media;
        return css(_templateObject(), media, baseImageUrl, imagePath, width, height, baseImageUrl, imagePath, width, height);
    });
}, "  @media (min-width:780px){flex-direction:row-reverse;}");
var LogoWrapper = /*#__PURE__*/ styled("div", {
    target: "ea3dla21"
})("position:relative;");
var Logo = /*#__PURE__*/ styled("span", {
    target: "ea3dla22"
})("display:inline-flex;margin:0.3125rem 0.625rem;@media (min-height:400px) or (min-width:800px){position:absolute;left:0;bottom:1rem;margin:0;padding:0.25rem 0.625rem;background:#fffb;}img{width:auto;height:25px;vertical-align:bottom;}");
export { Wrapper, LogoWrapper, Logo };
